import DisplayUseSepolia from 'components/nft/DisplayUseSepolia'
import { getDisplayType } from 'redux/actions/displayActions'
import { getBrandName } from 'util/brandUtils'

export default function DisplayNoWallet() {
    return (
        <div style={{ color: 'black' }}>
            <p
                style={{
                    textAlign: 'center',
                    padding: '2em',
                    border: '0.5px solid black',
                }}
            >
                You do not have an Ethereum wallet installed. Please visit{' '}
                <a
                    href='https://metamask.io/download.html'
                    rel='noreferrer'
                    target='blank'
                >
                    this Metamask link
                </a>{' '}
                to install Metamask.
            </p>
            <p>
                After you have installed Metamask and set up at least one Ethereum
                account, refresh this page to connect your account to{' '}
                {getBrandName(getDisplayType())}.
            </p>
            <DisplayUseSepolia />
        </div>
    )
}